class PfCardCarousel {
	constructor(section) {
		this.section = section;
		this.container = section.querySelector(".pf-card-carousel__container");
		this.prevBtn = section.querySelector(".pf-card-carousel__button--prev");
		this.nextBtn = section.querySelector(".pf-card-carousel__button--next");

		if (!this.container) return;

		this.scrollAmount = 343 + 16;
		this.isDragging = false;
		this.dragStartX = 0;
		this.dragStartScrollLeft = 0;
		this.activePointerId = null;
		this.bindEvents();
		this.bindCtaProxy();
	}

	bindEvents() {
		this.prevBtn?.addEventListener("click", () => {
			this.container.scrollBy({ left: -this.scrollAmount, behavior: "smooth" });
		});

		this.nextBtn?.addEventListener("click", () => {
			this.container.scrollBy({ left: this.scrollAmount, behavior: "smooth" });
		});

		// Desktop: allow click-and-drag to scroll the carousel (mouse only).
		this.container.addEventListener("pointerdown", (e) => {
			if (e.pointerType !== "mouse") return;
			if (e.button !== 0) return;
			// Only enable on desktop; mobile already uses native scroll.
			if (window.matchMedia && !window.matchMedia("(min-width: 768px)").matches) return;
			if (e.target && e.target.closest?.("button, a, input, textarea, select, label")) return;

			this.isDragging = true;
			this.dragStartX = e.clientX;
			this.dragStartScrollLeft = this.container.scrollLeft;
			this.activePointerId = e.pointerId;
			this.container.classList.add("is-dragging");

			// Prevent text selection while dragging.
			e.preventDefault();
			try {
				this.container.setPointerCapture(e.pointerId);
			} catch (_) {}
		});

		this.container.addEventListener("pointermove", (e) => {
			if (!this.isDragging) return;
			const dx = e.clientX - this.dragStartX;
			this.container.scrollLeft = this.dragStartScrollLeft - dx;
			e.preventDefault();
		});

		const endDrag = () => {
			if (!this.isDragging) return;
			this.isDragging = false;
			this.dragStartX = 0;
			this.dragStartScrollLeft = 0;
			this.activePointerId = null;
			this.container.classList.remove("is-dragging");
		};

		this.container.addEventListener("pointerup", (e) => {
			endDrag();
			try {
				if (this.activePointerId != null) this.container.releasePointerCapture(e.pointerId);
			} catch (_) {}
		});

		this.container.addEventListener("pointercancel", endDrag);
	}

	bindCtaProxy() {
		const ctaCards = this.section.querySelectorAll(".pf-card-carousel__cta-card");

		const positionProxyForCard = (ctaCard) => {
			const proxy = ctaCard.querySelector(".pf-card-carousel__cta-proxy");
			const realButton = ctaCard.querySelector(".add-to-cart-btn");
			if (!proxy || !realButton) return;

			const cardRect = ctaCard.getBoundingClientRect();
			const btnRect = realButton.getBoundingClientRect();

			proxy.style.left = `${btnRect.left - cardRect.left}px`;
			proxy.style.top = `${btnRect.top - cardRect.top}px`;
			proxy.style.width = `${btnRect.width}px`;
			proxy.style.height = `${btnRect.height}px`;

			// Match border radius for a seamless overlay.
			const radius = window.getComputedStyle(realButton).borderRadius;
			proxy.style.borderRadius = radius;
		};

		ctaCards.forEach((ctaCard) => {
			const proxy = ctaCard.querySelector(".pf-card-carousel__cta-proxy");
			const realButton = ctaCard.querySelector(".add-to-cart-btn");
			if (!proxy || !realButton) return;

			const update = () => positionProxyForCard(ctaCard);
			update();

			// Keep overlay aligned to the button.
			window.addEventListener("resize", update);
			window.addEventListener(
				"scroll",
				() => {
					// Throttle lightly.
					window.requestAnimationFrame(update);
				},
				{ passive: true }
			);

			proxy.addEventListener("mouseenter", () => {
				realButton.classList.add("pf-card-carousel__cta-hover");
			});

			proxy.addEventListener("mouseleave", () => {
				realButton.classList.remove("pf-card-carousel__cta-hover");
			});

			proxy.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();

				// If the button is disabled, do nothing.
				if (realButton.disabled) return;

				const essentialForm = document.querySelector(
					'form[data-essential-cart-element="essential-sticky-add-to-cart-form"]'
				);

				if (essentialForm) {
					const essentialButton = essentialForm.querySelector(
						'[data-essential-cart-element="add-to-cart-button"]'
					);
					if (essentialButton) essentialButton.click();
					return;
				}

				// Backup: submit the Shopify product form inside the CTA card.
				const productForm = ctaCard.querySelector("form[data-product-form]");
				if (productForm?.requestSubmit) productForm.requestSubmit();
				else productForm?.submit?.();
			});
		});
	}
}

function initPfCardCarousels() {
	document.querySelectorAll(".pf-card-carousel").forEach((el) => {
		if (el.dataset.initialized === "true") return;
		el.dataset.initialized = "true";
		new PfCardCarousel(el);
	});
}

document.addEventListener("DOMContentLoaded", initPfCardCarousels);
document.addEventListener("shopify:section:load", initPfCardCarousels);